import { Button, Dialog } from '@/components/UI'
import type { GiftCodeData } from '@/schemas/v2'
import { QRCodeCanvas } from 'qrcode.react'

type Props = {
  opened: boolean
  onClose: () => void
  /** GIFT_CODE 種別のコード情報 */
  giftCode?: GiftCodeData | null
  /** Giftee Box 発行URL */
  gifteeUrl?: string | null
  /** 賞品名（ダイアログタイトルに使用） */
  prizeName?: string | null
  onConfirm: () => void
}

/**
 * ギフトコード / Giftee 表示ダイアログ。
 * codeDisplayType に応じてコード文字列 / URLリンク / QRコード を切り替え表示する。
 * Figma: node 553-18736
 */
export function DialogV2PrizeExchange({ opened, onClose, giftCode, gifteeUrl, prizeName, onConfirm }: Props) {
  const renderCodeContent = () => {
    if (gifteeUrl) {
      return (
        <div className="flex flex-col items-center gap-2">
          <p className="text-center text-[13px] leading-[20px] text-gray-600">Giftee でギフトを受け取れます。</p>
          <a
            href={gifteeUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-[14px] font-bold leading-[20px] text-[#ff8a00] underline"
          >
            Giftee でギフトを受け取る
          </a>
        </div>
      )
    }

    if (!giftCode) return null

    const { code, url, codeDisplayType } = giftCode
    const showCode = ['CODE', 'CODE_URL'].includes(codeDisplayType)
    const showQr = ['QR', 'QR_URL'].includes(codeDisplayType)
    const showUrl = ['URL', 'CODE_URL', 'QR_URL'].includes(codeDisplayType)

    return (
      <div className="flex flex-col items-center gap-2 w-full">
        {showCode && (
          <div className="w-full rounded-[8px] bg-gray-50 p-3 text-center">
            <p className="text-[12px] leading-[18px] text-gray-500">ギフトコード</p>
            <p className="mt-1 text-[18px] font-bold leading-[24px] tracking-widest text-black">{code}</p>
          </div>
        )}
        {showQr && (
          <div className="flex flex-col items-center gap-1">
            <QRCodeCanvas value={code} size={160} />
            <p className="text-[12px] leading-[18px] text-gray-500">{code}</p>
          </div>
        )}
        {showUrl && url && (
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className="text-[14px] font-bold leading-[20px] text-[#ff8a00] underline"
          >
            特典ページを開く
          </a>
        )}
      </div>
    )
  }

  return (
    <Dialog
      selectorState={opened}
      closeFunc={onClose}
      title={gifteeUrl ? (prizeName ?? 'Giftee ギフト') : (prizeName ?? 'ギフトコード')}
      compact
    >
      <div className="flex flex-col gap-4 px-4 py-6">
        {renderCodeContent()}
        {!gifteeUrl && (
          <p className="text-center text-[13px] leading-[20px] text-gray-600">コードを確認の上、ご利用ください。</p>
        )}
        <Button label="確認しました" variant="primary" size="md" fullWidth onClick={onConfirm} />
      </div>
    </Dialog>
  )
}
